var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"display-3 text-xs-center"},[_vm._v("Bienvenido")]),_vm._v(" "),_c('div',{staticClass:"display-2 text-xs-center"},[_vm._v(_vm._s(_vm.userName))])])],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a31d2d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/home.vue
// module id = 7ZNK
// module chunks = 0